import * as React from 'react';
import { Bar as CurrentChart } from 'react-chartjs-2';
import { TickOptions } from 'chart.js';
import { SharedChartRenderProps, getOptions } from './Shared';
import { observer } from 'mobx-react';

type ChartRenderProps = SharedChartRenderProps;

@observer
export class ChartRender extends React.Component<ChartRenderProps> {
   
    public render() {
       
        return  (
            <div className="widget-frame">
                <CurrentChart
                
                    options={getOptions(this.props.CurrentChart, {
                        scales: {
                            yAxes: [{
                                display: true,
                                ticks: {
                                    beginAtZero: true,
                                    callback: (val) => `${val} ${this.props.CurrentChart.measurementUnit}`
                                } as TickOptions,
                                scaleLabel: {
                                    display: true,
                                    labelString: this.props.CurrentChart.name || '',
                                }
                            }]
                        }
                    })}
                    {...this.props}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/container/Chart/renders/Bar.tsx